export default "__VITE_ASSET__Cmyn9WGI__"